import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PageComponent} from '../../page.component';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {ResetPasswordSuccessDialogComponent} from '../../dialogs/reset-password-success/reset-password-success.dialog.component';
import {ValidationService} from '../../services/validation.service';

@Component({
  selector: 'mp-reset-password',
  templateUrl: 'reset-password.component.html',
  styleUrls: ['reset-password.component.css']
})
export class ResetPasswordComponent extends PageComponent implements OnInit {

  form: FormGroup;
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  loading = false;

  errFailure: boolean;

  constructor(private formBuilder: FormBuilder,
              private readonly apiService: ApiService,
              private readonly validationService: ValidationService,
              private dialog: MatDialog,
              private router: Router) {
    super();
  }

  isLightPage(): boolean {
    return true;
  }

  canGoBack(): boolean {
    return true;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: this.emailControl
    });

    this.resetErrors();
  }

  onSubmit(): void {
    let emailValue = this.form.controls.email.value;
    emailValue = this.validationService.sanitizeEmail(emailValue);

    if (this.form.invalid) {
      return;
    }

    this.resetErrors();
    this.loading = true;

    this.apiService.resetPassword(emailValue)
      .subscribe(() => {
        this.loading = false;

        this.dialog.open(ResetPasswordSuccessDialogComponent, {
          disableClose: true,
          data: {
            email: emailValue,
            isConfirm: false
          }
        });

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.errFailure = true;
      });
  }

  private resetErrors(): void {
    this.errFailure = false;
  }
}
